/* eslint-disable camelcase */
export default class Role {
  constructor ({ role_id, role_name }) {
    this.id = role_id || ''
    this.name = role_name || ''
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/models/Role.js